<app-info-adresse [adresse]="coordonneesClient?.adresseClient | adresse"></app-info-adresse>
<form class="dsd-p-0" [formGroup]="controleFormGroup">
  <dsd-container>
    <dsd-fieldset [quietValidate]="true">
      <span slot="legend">
        <h2 class="dsd-t-4">{{ 'caad.modifier.coordonnees.nouvelleAdresse' | translate }}</h2>
      </span>
      <p slot="description" class="dsd-mb-md">{{ 'caad.modifier.coordonnees.adresseObligatoire' | translate }}</p>
      <dsd-input
        identifier="rueCanada"
        required="true"
        class="input-long"
        formControlName="rueCanada"
        name="rueCanada"
        maxlength="30"
        [error]="erreursFormAdresse.rue.hasError"
        [quietValidate]="true"
        (focusin)="configAutoCompleteAdressCanada()">
        <span slot="label">{{ 'formulairePosteCanada.coordonnees.rue.titre' | translate }}</span>
        <span slot="hint" id="pca-help-text">{{
          'caad.modifier.coordonnees.libelle.maximumCaracteres' | translate
        }}</span>
        <span slot="error">
          <app-erreur-input [erreurInput]="erreursFormAdresse.rue"></app-erreur-input>
        </span>
      </dsd-input>
      <dsd-input
        identifier="appartementCanada"
        required="false"
        name="appartementCanada"
        input-width="15"
        formControlName="appartementCanada"
        [error]="erreursFormAdresse.appartement.hasError"
        [quietValidate]="true"
        maxlength="8"
        hide-required-labelling="false">
        <span slot="label">
          {{ 'formulairePosteCanada.coordonnees.appartement.titre' | translate }}
        </span>
        <span slot="error">
          <app-erreur-input [erreurInput]="erreursFormAdresse.appartement"></app-erreur-input>
        </span>
      </dsd-input>
      <dsd-input
        identifier="villeCanada"
        required="true"
        class="input-long"
        formControlName="villeCanada"
        name="villeCanada"
        maxlength="25"
        [error]="erreursFormAdresse.ville.hasError"
        [quietValidate]="true">
        <span slot="label">{{ 'formulairePosteCanada.coordonnees.ville.titre' | translate }}</span>
        <span slot="hint">{{ 'formulairePosteCanada.coordonnees.ville.hint' | translate }}</span>
        <span slot="error">
          <app-erreur-input [erreurInput]="erreursFormAdresse.ville"></app-erreur-input>
        </span>
      </dsd-input>
      <dsd-select
        identifier="provinceCanada"
        name="provinceCanada"
        class="province"
        required="true"
        formControlName="provinceCanada"
        [error]="erreursFormAdresse.province.hasError"
        [quietValidate]="true">
        <span slot="label">{{ 'formulairePosteCanada.coordonnees.province.titre' | translate }}</span>
        <span slot="error"><app-erreur-input [erreurInput]="erreursFormAdresse.province"></app-erreur-input></span>
        <span slot="options">
          <option
            *ngFor="
              let province of listeProvince | displayDonneesRef: 'formulairePosteCanada.donneeReference.provinces.CA-'
            "
            [value]="province">
            {{ 'formulairePosteCanada.donneeReference.provinces.CA-' + province | translate }}
          </option>
        </span>
      </dsd-select>
      <dsd-input
        identifier="codePostalCanada"
        name="codePostalCanada"
        input-width="15"
        required="true"
        formControlName="codePostalCanada"
        maxlength="7"
        minlength="6"
        [error]="erreursFormAdresse.codePostal.hasError"
        [quietValidate]="true">
        <span slot="label">
          {{ 'formulairePosteCanada.coordonnees.codePostal.titre' | translate }}
        </span>
        <span slot="hint">{{ 'formulairePosteCanada.coordonnees.codePostal.hint' | translate }}</span>
        <span slot="error">
          <app-erreur-input [erreurInput]="erreursFormAdresse.codePostal"></app-erreur-input>
        </span>
      </dsd-input>
    </dsd-fieldset>
  </dsd-container>

  <div class="zone-btn">
    <dsd-button variant="primary" (dsdButtonClick)="onSubmit()" full-width="xs">{{
      'caad.button.valider' | translate
    }}</dsd-button>
    <dsd-button (dsdButtonClick)="annulerModification()" full-width="xs">{{
      'caad.button.annuler' | translate
    }}</dsd-button>
  </div>
</form>
